
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { lAreaData } from '@/const/LAreaData';
import { getCustomerList } from '@/api/branch';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'customerDialog'
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  customerVisible!: Boolean ;
  @Prop({
    type: String,
    default: ''
  })
  servicerCompanyId!: '';
  @Watch('customerVisible', {
    deep: true,
    immediate: true
  })
  refreshList(value: boolean) {
    if (value === true) {
      this.clearButton();
    }
  }

  private listQuery = {
    name: '',
    address: [],
    page: 1
  };

  private listData = {
    more: false,
    customerList: []
  };

  private loading = false;
  private moreLoading = false;
  private radioSelected = '';
  private lAreaData!: any;
  private defaultProps: any = {
    children: 'child',
    label: 'name',
    value: 'id'
  };
  private selectAreaBean: any = {};

  created() {
    this.lAreaData = lAreaData;
    this.lAreaData.map((item:any) => {
      if (item && item.child && item.child.length === 0) {
        (item.child as any) = undefined;
      } else {
        item && item.child && item.child.map((temp:any) => {
          if (temp && temp.child && temp.child.length === 0) {
            (temp.child as any) = undefined;
          }
        });
      }
    });
  }
  resetData() {
    this.listQuery.name = '';
    this.listQuery.address = [];
    this.listQuery.page = 1;
    this.listData = {
      more: false,
      customerList: []
    };
  }
  close() {
    this.$emit('close', false);
    this.resetData();
  }
  moreCusData() {
    this.moreLoading = true;
    this.listQuery.page += 1;
    this.getCustomerList();
  }

  getCustomerList() {
    this.loading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      company_level: (UserModule.getCompany as any).company_level,
      servicer_company_id: this.servicerCompanyId,
      name: this.listQuery.name,
      page: this.listQuery.page
      // address: this.listQuery.address
    };
    getCustomerList(params)
      .then(res => {
        if (res.data === null || (res.data && res.data.page_count <= this.listQuery.page)) {
          this.listData.more = false;
        } else {
          this.listData.more = true;
        }
        if (res.data && res.data.list) {
          this.listData.customerList = this.listData.customerList.concat(...res.data.list);
        } else {
          this.listData.more = false;
          this.listData.customerList = []
        }
        this.loading = false;
        this.moreLoading = false;
      })
      .catch(err => {
        this.listData.more = false;
        this.listData.customerList = []
        this.loading = false;
        this.moreLoading = false;
        let aa = err.msg;
      });
  }

  selectedCustomerResult() {
    if (this.radioSelected === '') {
      this.$notify({
        title: '提示',
        message: '请选择客户',
        duration: 3000,
        offset: 100,
        type: 'error'
      });
      return;
    }
    this.$emit('selectcus', this.radioSelected);
  }
  clearButton() {
    this.resetData();
    this.getCustomerList();
  }
  searchData() {
    this.listQuery.page = 1;
    this.listData = {
      more: false,
      customerList: []
    };
    this.getCustomerList();
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
}
